import { Chip } from "@mui/material";
import {
  LISTING_PLATFORM_COLORS,
  LISTING_PLATFORM_OPTIONS,
} from "../listingPlatform";

// Sized like the grid's SingleSelectCell chips. An unknown or missing
// platform renders nothing rather than guessing.
export function PlatformChipCell({ platform }: { platform?: string | null }) {
  const option = LISTING_PLATFORM_OPTIONS.find((o) => o.value === platform);
  if (!option) return null;

  const colors = LISTING_PLATFORM_COLORS[option.value];

  return (
    <Chip
      label={option.label}
      size="small"
      sx={{
        height: 20,
        fontSize: "0.75rem",
        fontWeight: 600,
        bgcolor: colors.background,
        color: colors.text,
        "& .MuiChip-label": {
          px: 1,
        },
      }}
    />
  );
}
